import { EntityAdapter, EntityState, createEntityAdapter } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import * as reportsActions from "./reports.actions";
import { ReportGeneratorDto } from "../interfaces/report_generator_dto";
import { ReportConfigurationDto } from "../interfaces/report_configuration_dto";

export const reportFeatureKey = "reports";

export interface ReportGeneratorState extends EntityState<ReportGeneratorDto> {
}

export interface ReportConfigurationState extends EntityState<ReportConfigurationDto> {
}

export interface ReportsState {
  reportGenerators: ReportGeneratorState;
  reportConfigurations: ReportConfigurationState; 
  isLoaded: boolean;
}


export const reportGeneratorAdapter: EntityAdapter<ReportGeneratorDto> = createEntityAdapter<ReportGeneratorDto>({
  selectId: (report: ReportGeneratorDto) => report?.report_generator_id || 0, 
  sortComparer: false,
});

export const reportConfigurationAdapter: EntityAdapter<ReportConfigurationDto> = createEntityAdapter<ReportConfigurationDto>({
  selectId: (reportConfiguration: ReportConfigurationDto) =>
    reportConfiguration?.report_configuration_id || 0,
  sortComparer: false,
});

export const initialReportState: ReportsState = {
  reportGenerators: reportGeneratorAdapter.getInitialState(),
  reportConfigurations: reportConfigurationAdapter.getInitialState(),
  isLoaded: false,
};

// Reducer definition
const reportsReducer = createReducer(
  initialReportState,

  on(reportsActions.upsertReport, (state, { report }) => ({
    ...state,
    reportGenerators: reportGeneratorAdapter.upsertOne(report, state.reportGenerators),
    isLoaded: false,
  })),

  // Load Reports action
  on(reportsActions.loadReports, (state) => ({
    ...state,
    isLoaded: false,
  })),

  // Load Reports Success
  on(reportsActions.loadReportsSuccess, (state, { reports }) => ({
    ...state,
    reportGenerators: reportGeneratorAdapter.setAll(reports, state.reportGenerators),
    isLoaded: true,
  })),

  // Delete Report Success (for report generators)
  on(reportsActions.deleteReportSuccess, (state, { report_generator_id }) => ({
    ...state,
    reportGenerators: reportGeneratorAdapter.removeOne(report_generator_id, state.reportGenerators),
  })),

  // Load Report Configurations Success
  on(reportsActions.loadReportConfigurationsSuccess, (state, { reportConfigurations }) => ({
    ...state,
    reportConfigurations: reportConfigurationAdapter.setAll(reportConfigurations, state.reportConfigurations),
  })),
);

export function reportReducer(
  state: ReportsState = initialReportState,
  action: Action
) {
  return reportsReducer(state, action);
}
